import axios from "axios";

export const analyzeProject = async ({ projectName, projectDescription }) => {
 

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_AI_ADVISOR_REST_URL}/api/analyze`,
      // process.env.REACT_APP_AI_API_KEY,
      {
        projectName,  
        useCaseDescription: projectDescription,
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error analyzing project:", error);
    throw error.response?.data || { message: "Something went wrong" };
  }
};
